import React from 'react'
import { GROUP, DIVISIONS, BRAND } from '../../CompanyInfo';

const AboutUs = () => {
    return (
        <div className="p-6 max-w-4xl mx-auto container " style={{ minHeight: 500 }}>
            <div className="bg-white p-4 m-5">
                <h3 className='text-center mb-3' style={{ color: BRAND.purple, fontWeight: 700 }}>
                    About Us
                </h3>

                <div style={{ fontSize: 20, marginBottom: 8 }}>
                    Welcome to <span style={{ fontWeight: 600 }}>{GROUP.shortName}</span> &mdash; Trusted
                    Partner in Pharmaceutical Distribution, {GROUP.since.toLowerCase()}.
                </div>

                <p>
                    {GROUP.name} is a Karnataka-based pharmaceutical and veterinary distribution house
                    operating from Udupi and Shimoga. Through <strong>Sarvodaya Agencies</strong> and
                    our group company <strong>Vetrem Pharma</strong>, we supply prescription medicines,
                    over-the-counter products, veterinary formulations, medical supplies and wellness
                    products to pharmacies, hospitals, clinics and healthcare facilities across the region.
                </p>

                <p>
                    With a licensed and fully compliant supply chain, temperature-aware storage and a
                    dedicated field team, our mission is to support your operations with dependable
                    stock availability, regulatory compliance and prompt delivery.
                </p>

                <h5 className='mt-4 mb-3' style={{ color: BRAND.green, fontWeight: 700 }}>
                    Our Divisions
                </h5>

                <div className='row'>
                    {DIVISIONS.map((d) => (
                        <div className='col-md-4 mb-3' key={d.key}>
                            <div className='p-3 h-100' style={{
                                border: "1px solid #e3e3e3",
                                borderRadius: 10,
                                borderTop: "4px solid " + BRAND.green,
                            }}>
                                <img src={d.logo} alt={d.name} height={48} className='mb-2' />
                                <div style={{ fontWeight: 700, color: BRAND.purple }}>{d.name}</div>
                                <small style={{ color: BRAND.green, fontWeight: 600 }}>{d.label}</small>
                                <div className='mt-2' style={{ fontSize: 13 }}>
                                    {d.city}, {d.state} &ndash; {d.pincode}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default AboutUs
